<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Skapa API-Nyckel</p>
			</header>
			<section class="modal-card-body">
				<div class="top-box" :style="mobile">
					<div class="row">
						<div class="field name">
							<label class="label">Namn</label>
							<div class="control">
								<textarea
									class="textarea no-resize"
									v-model="apiKeyModel.name"
									rows="2"
									placeholder="API-Nyckel namn"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<div class="buttons">
					<button
						class="button is-info"
						:class="loading ? 'is-loading' : ''"
						@click="save(apiKeyModel)"
					>
						<span class="icon is-white"><i class="fas fa-save"/></span
						><span>Spara</span>
					</button>
					<button class="button is-dark" @click="cancel" v-if="!isMobile">
						<span class="icon"><i class="fas fa-backward"/></span>
						<span>Tillbaka</span>
					</button>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
	props: {
		message: {
			type: String,
			default: () => 'Test'
		},
		customerId: {
			type: String
		},
		loading: {
			type: Boolean
		}
	},
	data() {
		return {
			apiKeyModel: {}
		};
	},
	computed: {
		...mapState('apiKeyStore', ['searchParams']),
		...mapGetters('apiKeyStore', ['apiKeys', 'selectedApiKey']),
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		save(model) {
			this.$emit('confirm', model);
		},
		cancel() {
			this.$emit('cancel');
		},
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/colors.scss";

.column .title {
  margin-bottom: 16px;
}

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;

  .field {
    margin-left: 10px;
    margin-right: 10px;

    &.name {
      flex: 1;
    }

    &.description {
      flex: 2;
    }

    .label {
      font-size: 12px;
    }

    &.select.is-multiple {
      flex-grow: 1;
      max-width: 250px;
    }
  }

  .textarea {
    background: white;
    border-radius: 2px;
  }

  .buttons {
    margin: 2rem 10px 0 10px;
    display: flex;
    justify-content: space-between;
    flex-flow: row-reverse;

    .button {
      border-radius: 2px;
      width: 110px;
    }
  }

  .row {
    display: flex;
    position: relative;
  }
}

.no-list {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $lightest-grey;
  text-align: center;
}
</style>
